class ProductDetailSticky extends HTMLElement {
  constructor() {
    super();
    this.isVisible = false;
    this.scrollThreshold = this.getAttribute("scroll-threshold") || 300;
    this.fadeInDuration = 300;
  }

  connectedCallback() {
    this.setupScrollListener();
    this.setupInitialState();
  }

  disconnectedCallback() {
    this.removeScrollListener();
  }

  setupInitialState() {
    this.style.opacity = "0";
    this.style.transition = `opacity ${this.fadeInDuration}ms ease-in-out`;
    this.style.visibility = "hidden";
  }

  setupScrollListener() {
    this.handleScroll = this.handleScroll.bind(this);
    window.addEventListener("scroll", this.handleScroll, { passive: true });
  }

  removeScrollListener() {
    if (this.handleScroll) {
      window.removeEventListener("scroll", this.handleScroll);
    }
  }

  handleScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.scrollThreshold && !this.isVisible) {
      this.fadeIn();
    } else if (scrollTop <= this.scrollThreshold && this.isVisible) {
      this.fadeOut();
    }
  }

  fadeIn() {
    this.style.opacity = "1";
    this.isVisible = true;
    this.style.visibility = "visible";
  }

  fadeOut() {
    this.style.opacity = "0";
    this.isVisible = false;
    this.style.visibility = "hidden";
  }
}

if (!customElements.get("product-detail-sticky")) {
  customElements.define("product-detail-sticky", ProductDetailSticky);
}
